import type { Services } from '../../types/services';
import type { AuthAccount } from '../../types/auth';
import { withDevPermissions } from '../../Services/devPermissions';

const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';

interface State {
  firstName: string;
  lastName: string;
  isAdmin: boolean;
  partners: string[];
  partnerids: string[];
  permissions: string[];
  error: string;
}

const initialState: State = {
  firstName: '',
  lastName: '',
  isAdmin: false,
  partners: [],
  partnerids: [],
  permissions: [],
  error: '',
};

interface Action {
  type: typeof SET_ACCOUNT_INFO;
  payload: AuthAccount;
}

export const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ACCOUNT_INFO: {
      const accountInfo = action.payload as AuthAccount;
      const { roles, given_name, family_name, partners, partnerids, permissions } =
        accountInfo.idTokenClaims;

      const admin = (roles || []).includes('Admin');
      const partner =
        (roles || []).includes('Partner') &&
        (partnerids || []).filter((val: string) => val !== 'NONE').length > 0;
      return {
        ...state,
        isAdmin: admin,
        isPartnerUser: partner,
        firstName: given_name,
        lastName: family_name,
        partners: partners || [],
        partnerids: partnerids || [],
        // Unions REACT_APP_DEV_PERMISSIONS in a local run, where the token is minted against
        // deployed dev and so cannot carry a permission that exists only in the harness database.
        // Returns the token's list untouched everywhere else — see Services/devPermissions.
        permissions: withDevPermissions(permissions || []),
      };
    }
    default:
      return state;
  }
};

export const actions = (services: Services) => ({
  setAccountInfo: () => ({
    type: SET_ACCOUNT_INFO,
    payload: services.auth.GetAccount(),
  }),
});

export type AuthActions = ReturnType<typeof actions>;
